<template>
  <div>
    <b-container>
      <b-row>
        <b-col md="12">
          <br /><br />
          <div class="closeBtn mb-2 text-right">
            <p @click="closeCurrentTab()" class="btn m-0">
              <i class="fas fa-window-close fa-4x text-danger"></i>
            </p>
          </div>
          <h6 class="alert alert-danger" v-if="CsvError">
            Invalid format/Missing Data, Please check the excel sheet
          </h6>
          <h6 class="alert alert-success text-center" v-if="responseSuccess.created">
            {{ responseSuccess.created[0] }}
          </h6>
          <div class="selectExcelFile d-flex align-items-center">
            <b-form-file ref="selectedExcelFile" style="display: none" v-model="excelSheet"
              placeholder="Select Excel File"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></b-form-file>
            <b-button variant="info" v-if="excelSheet == null" pill size="md" @click="selectExcelFile()"><i
                class="fas fa-file-excel mr-2"></i>Select Excel File</b-button>

            <h6 v-else class="text-dark font-weight-bolder">
              {{ excelSheet.name }}
              <span v-if="!outcomeBtn.disabled" class="text-danger btn m-0 p-0" @click="removeExcelSheet()"><i
                  class="fas fa-trash ml-2"></i></span>
            </h6>
            <b-button v-if="excelTable.length == 0" variant="outline-success" @click="checkExcelSheet"
              class="text-info ml-3" :disabled="excelSheet == null"><i class="fas fa-upload fa-2x ml-2"></i></b-button>
          </div>
          <div class="progressBar" v-if="loadData">
            <b-progress :value="value" :max="max" show-progress animated variant="success"></b-progress>
          </div>
          <div v-if="excelTable.length != 0">
            <table class="table">
              <thead>
                <tr>
                  <th>Si.No</th>
                  <th>Course Outcome</th>
                  <th>Course Description</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cOutcome, cOutcomeIndex) in excelTable" :key="cOutcomeIndex">
                  <td>
                    <b-form-input v-model="cOutcome.si_no" placeholder="Serial number"
                      :disabled="outcomeBtn.disabled"></b-form-input>
                  </td>
                  <td>
                    <b-form-input v-model="cOutcome.name" placeholder="Course Outcome" :disabled="outcomeBtn.disabled"
                      :class="{ 'is-invalid': responseErrors.code }"></b-form-input>
                    <span class="text-danger" v-if="responseErrors.code">{{
                        responseErrors.code[0]
                    }}</span>
                  </td>
                  <td>
                    <b-form-textarea :class="{ 'is-invalid': responseErrors.outcome }" :disabled="outcomeBtn.disabled"
                      v-model="cOutcome.description" placeholder="Enter Description..." rows="3" max-rows="6">
                    </b-form-textarea>
                    <span class="text-danger" v-if="responseErrors.outcome">{{
                        responseErrors.outcome[0]
                    }}</span>
                  </td>
                  <td>
                    <span v-if="!outcomeBtn.disabled" class="text-danger btn m-0 p-0"
                      @click="excelTable.splice(cOutcomeIndex, 1)"><i class="fas fa-trash"></i></span>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-form-group>
              <b-button @click="createCourseOutcome()" class="d-flex align-items-center" v-html="outcomeBtn.text"
                variant="primary" size="md" :disabled="outcomeBtn.disabled">{{ outcomeBtn.text }}</b-button>
            </b-form-group>
          </div>
          <div class="sampleCsv" v-if="excelTable.length == 0">
            <p class="text-info d-flex align-items-baseline">
              <b class="text-dark mr-2">Note: </b> While preparing the Excel sheet, only include the serial number,
              course outcome name, and course outcome description. Headers are not required.
              <br />
              Please refer to the sample image below:
            </p>
            <img src="../../../../../assets/images/courseOutcome.png" alt="" class="img-fluid" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import readXlsxFile from "read-excel-file";
export default {
  data() {
    return {
      loadData: false,
      value: 25,
      max: 100,
      excelSheet: null,
      excelTable: [],
      checkCsv: [],
      CsvError: false,
      outcomeBtn: {
        text: "Submit",
        disabled: false,
      },
      responseErrors: {},
      responseSuccess: {},
    };
  },
  methods: {
    async createCourseOutcome() {
      const courseId = this.$route.params.course_id;
      this.outcomeBtn.text =
        `This process will take a few seconds, please wait` +
        `<div class="spinner-grow text-white ml-3"></div>`;
      this.outcomeBtn.disabled = true;

      for (const cOutcome in this.excelTable) {
        let courseOutcome = await this.storeCourseOutcome(cOutcome, courseId);

        courseOutcome;
      }
    },
    async storeCourseOutcome(cOutcome, courseId) {
      const url = this.$store.getters.getAPIKey.courseOutcomes;
      let courseOutcome = {
        si_no: this.excelTable[cOutcome].si_no,
        code: this.excelTable[cOutcome].name,
        outcome: this.excelTable[cOutcome].description,
        course_id: courseId,
      };
      await axios
        .post(url, courseOutcome)
        .then(() => {
          this.$toast.info(`${this.excelTable[cOutcome].name} is created successfuly`, {
            position: "top-right",
            duration: 3000,
          });
          if (cOutcome == this.excelTable.length - 1) {
            this.responseSuccess["created"] = "Outcomes Created";
            this.$toast.success("Course Outcomes are successfully created.", {
              position: "top",
              duration: 0,
            });
            this.clearResponse();
          }
          // console.log(response);
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          this.clearResponse();
          // console.log(error.response);
          this.$toast.warning(Object.keys(this.responseErrors)[0] + " " + "is required", {
            position: "top",
            duration: 3000,
          });
        });
    },
    clearResponse() {
      this.outcomeBtn.text = "Submit";
      setTimeout(() => {
        if (this.responseSuccess.created) {
          this.removeExcelSheet();
          this.$toast.clear();
          this.closeCurrentTab();
        }

        this.outcomeBtn.disabled = false;
        this.responseErrors = {};
        this.responseSuccess = {};
      }, 5000);
    },
    selectExcelFile() {
      this.$refs.selectedExcelFile.$refs.input.click();
    },
    removeExcelSheet() {
      this.excelTable = [];
      this.excelSheet = null;
    },
    async checkExcelSheet() {
      this.loadData = true;
      this.checkCsv = [];
      await this.excelSheet;

      this.excelTable = [];

      await readXlsxFile(this.excelSheet).then((csv) => {
        this.value = this.value + 10;
        this.checkCsv = csv;
      });

      let checkValidation;
      await this.checkCsv.forEach((csv) => {
        if (csv.length != 3) {
          return (checkValidation = true);
        }
        if (this.checkCsv[this.checkCsv.length - 1].length <= 2) {
          return (checkValidation = false);
        }
      });

      if (checkValidation) {
        this.value = this.value + 10;
        this.CsvError = true;
        this.loadData = false;
        this.value = 50;
        this.removeExcelSheet();
        setTimeout(() => {
          this.CsvError = false;
        }, 5000);
      } else {
        this.value = this.value + 20;
        await this.checkCsv.forEach((cOData) => {
          this.excelTable.push({ si_no: cOData[0], name: cOData[1], description: cOData[2] });
        });
        this.loadData = false;
        this.value = 50;
      }
    },
  },
};
</script>
